(function unitOrgControlModuleDefinition() {
    'use strict';

    angular.module('CustomControlUser', ['angucomplete-alt', 'angucompleteExtend'])
        .directive('dynamicUser', ['$translate', 'userService', 'errorsExtend',
            function ($translate, userService, errors) {

                return {
                    controller: [
                    '$scope', '$element', '$attrs', '$uibModal', 'config', 'errorsExtend', 'userService', 'storageService', 'authExtend',
                   function collapsableMenuController($scope, $element, $attrs, $modal, config, errors, userService, storageService, authExtend) {
                       $scope.init = function () {
                           $scope.typedLength = 0;
                           $scope.parents = [];
                           $scope.inputValue = '';
                           $scope.afterLostFocus = false;
                           $scope.afterLostFocus = false;

                           if ($scope.data.metadataValue) {
                               userService.getById($scope.data.metadataValue).then(function (result) {
                                   $scope.selectedUser.nickName = result.nickName
                                   $scope.selectedUser.entityDescription = result.entityDescription;
                               }, function (error) {
                                   errors.showError(error);
                               });
                           }
                       };

                       $scope.selectedUser = {};

                       $scope.find =
                        {
                            FirstName: '',
                            NickName: '',
                            LastName: '',
                            organizationalUnitId: $scope.ouId,
                            showNoData: false
                        };

                       $scope.search = function () {
                           if (!$scope.selectedUser || !$scope.selectedUser.nickName) {
                               $scope.openModal();
                           }
                           else {
                               $scope.selectUser()
                           }
                       };

                       $scope.openModal = function () {
                           $scope.selectedUser = {};
                           var modalInstance = $modal.open({
                               templateUrl: '/app/directives/custom-control-user/custom-control-user-modal.html',
                               controller: 'UserSearchModalController',
                               size: 'lg',
                               resolve: {
                                   ouId: function () {
                                       return $scope.ouId;
                                   },
                                   info: function () {

                                   }
                               }
                           });

                           modalInstance.result.then(function (result) {                          
                               if (result ) {
                                   $scope.selectedUser = result;
                                   $scope.data.metadataValue = result.id;
                               }
                               else {
                                   $scope.selectedUser = {};
                                   $scope.data.metadataValue = undefined;
                               }
                           });
                       };

                       $scope.selectUser = function (item) {
                           userService.get($scope.selectedUser.nickName, null, null, null, $scope.ouId, null).then(function (result) {
                               if (result.value[0]) {
                                   if ($scope.selectedUser != null) {
                                       $scope.removeUser($scope.selectedUser);
                                   }
                                   $scope.selectedUser = result.value[0];
                                   $scope.data.metadataValue = result.value[0].id;
                               }
                               else {
                                   $scope.openModal();
                               }

                           }, function (result) {
                               $scope.openModal();
                           });
                       };

                       $scope.removeUser = function (item, index, $event) {
                           $scope.selectedUser = null;

                           if ($event) {
                               $event.stopPropagation();
                           }
                       };

                       $scope.changeValue = function () {
                           if (!$scope.data.metadataValue) {
                               $scope.removeUser();
                           }                               
                       }
                       
                       $scope.$watch("data.metadataValue", $scope.changeValue);
                       $scope.init();
                   }],

                    restrict: 'E',
                    templateUrl: '/app/directives/custom-control-user/custom-control-user.html',
                    link: function () {
                    }
                };
            }
        ]);

    angular.module('CustomControlUser')
    .directive('dynamicFilterUser', ['$translate', 'adminUserService', 'errorsExtend', function ($translate, userService, errors) {
        return {
            replace: true,
            require: '^form',
            restrict: 'E',

            controller: [
            '$scope', '$element', '$attrs', '$uibModal', 'config', 'errorsExtend', 'userService', 'storageService', 'authExtend',
            function ($scope, $element, $attrs, $modal, config, errors, userService, storageService, authExtend) {
                $scope.init = function () {
                    if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                        $scope.data.metadataSearchTypeFrom = 'GreaterThanOrEqual';
                        $scope.data.metadataSearchTypeTo = 'LessThanOrEqual';
                    }

                    $scope.typedLength = 0;
                    $scope.parents = [];
                    $scope.inputValue = '';
                    $scope.afterLostFocus = false;
                    $scope.afterLostFocus = false;
                };

                $scope.selectedUser = {};

                $scope.find =
                 {
                     FirstName: '',
                     NickName: '',
                     LastName: '',
                     organizationalUnitId: authExtend.getOrganizationId(),
                     organizationalUnitName: authExtend.getOrganizationName(),
                     showNoData: false
                 };

                $scope.search = function () {
                    if (!$scope.selectedUser || !$scope.selectedUser.nickName) {
                        $scope.openModal();
                    }
                    else {
                        $scope.selectUser()
                    }
                };

                $scope.openModal = function () {
                    $scope.selectedUser = {};

                    var modalInstance = $modal.open({
                        templateUrl: '/app/directives/custom-control-user/custom-control-user-modal.html',
                        controller: 'UserSearchModalController',
                        size: 'lg',
                        resolve: {
                            info: function () {

                            }
                        }
                    });

                    modalInstance.result.then(function (result) {
                        if (result && result.user) {
                            $scope.selectedUser = result;
                            $scope.data.metadataValueFrom = result.id;
                        }
                        else {
                            $scope.selectedUser = {};
                            $scope.data.metadataValueFrom = undefined;
                        }
                    });
                };

                $scope.selectUser = function (item) {
                    userService.get($scope.selectedUser.nickName, null, null, null, $scope.ouId, null).then(function (result) {
                        if (result[0]) {
                            if ($scope.selectedUser != null) {
                                $scope.removeUser($scope.selectedUser);
                            }
                            $scope.selectedUser = result[0];
                            $scope.data.metadataValueFrom = result[0].id;
                        }
                        else {
                            $scope.openModal();
                        }

                    }, function (result) {
                        $scope.openModal();
                    });
                };

                $scope.removeUser = function (item, index, $event) {
                    $scope.selectedUser = null;

                    if ($event) {
                        $event.stopPropagation();
                    }
                };

                $scope.init();
            }],


            link: function (scope, iElement, iAttrs, formCtrl) {

                scope.formCtrl = formCtrl;
            },
            templateUrl: '/app/directives/custom-control-user/custom-control-user-filter.html'
        };
    }]);
})();